import Pagination from '@material-ui/lab/Pagination';
import { Badge, DatePicker, Form, Input, Space, Select, InputNumber } from 'antd';
import _ from 'lodash';
import React, { Suspense, useEffect, useState } from "react";
import { CaretDownOutlined } from '@ant-design/icons';
import {
    injectIntl
} from "react-intl";
import { withRouter } from "react-router-dom";
import ActionEditDelete from '../../../components/ActionEditDelete';
import CustomButton from '../../../components/CustomButton';
import { useSubheader } from "../../../_metronic/layout";
import {
    Card,
    CardBody
} from "../../../_metronic/_partials/controls";
import moment from "moment";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
    actionGetListHistorySwapTON,
} from '../../../redux/transaction/actions';
import {
    formatCoin,
    formatCoinID,
    numberFormat
} from '../../lib/common';
import DetailSwapTON from './DetailSwapTON';

const { RangePicker } = DatePicker;
const formRef = React.createRef()
function ListSwapTON(props) {
    const suhbeader = useSubheader();
    const [visibleSearch, setVisibleSearch] = useState(false)
    const [visible, setVisible] = useState(false);
    const [checkbox, setCheckbox] = useState([]);
    const [visibleModalDetail, setVisibleModalDetail] = useState(false)
    const [recordModal, setRecordModal] = useState(null)
    const [filterModal, setFilterModal] = useState(null)
    const [date, setDate] = useState([null, null])

    const { intl } = props
    suhbeader.setTitle(intl.formatMessage({ id: 'SIDEBAR.LIST_SWAP_TON' }));
    const dispatch = useDispatch();
    const { dataSwapTON, listUserLoginPermission } = useSelector(state => ({
        dataSwapTON: state.transactionReducer.dataSwapTON,
        listUserLoginPermission: state.authReducer.listUserLoginPermission
    }), shallowEqual)
    const [totalXAUBuy, setTotalXAUBuy] = useState(dataSwapTON.sumXAUBuy || 0);
    const [totalTONSell, setTotalTONSell] = useState(dataSwapTON.sumTONSell || 0);
    useEffect(() => {
        (async () => {
            let dataReq = await dispatch(actionGetListHistorySwapTON({ page: 1 }));
            setTotalXAUBuy(dataReq.sumXAUBuy)
            setTotalTONSell(dataReq.sumTONSell)
        })()
    }, [])

    const onChangePage = async (_, page) => {
        let { user_name_source, user_name_destination, transactionID, email, mobile_source, type, start, end, start_ton, end_ton, start_xau, end_xau } = formRef.current.getFieldsValue()
        let filter = {
        }
        if (email)
            filter.email = email.trim()
        if (type) {
            filter.type = type
        }
        if (start) {
            filter.start = start
        }
        if (end) {
            filter.end = end
        }
        if (start_ton) {
            filter.start_ton = start_ton
        }
        if (end_ton) {
            filter.end_ton = end_ton
        }
        if (start_xau) {
            filter.start_xau = start_xau
        }
        if (end_xau) {
            filter.end_xau = end_xau
        }
        if (mobile_source)
            filter.mobile_source = mobile_source.trim()
        if (date && date.length > 0 && date[0]) {
            filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        await dispatch(actionGetListHistorySwapTON({ ...filter, page, user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '' }));
    }
    const onChangeDateRange = async (e) => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_ton, end_ton, start_xau, end_xau } = formRef.current.getFieldsValue()
        let data_filter = {}
        if (type) {
            data_filter.type = type
        }
        if (start) {
            data_filter.start = start
        }
        if (start_ton) {
            data_filter.start_ton = start_ton
        }
        if (end_ton) {
            data_filter.end_ton = end_ton
        }
        if (start_xau) {
            data_filter.start_xau = start_xau
        }
        if (end_xau) {
            data_filter.end_xau = end_xau
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        if (e && e.length > 1) {
            let dataReq = await dispatch(actionGetListHistorySwapTON({ date: [moment(e[0]).format('YYYY/MM/DD'), moment(e[1]).format('YYYY/MM/DD')], page: 1, user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '', ...data_filter }));
            setTotalXAUBuy(dataReq.sumXAUBuy)
            setTotalTONSell(dataReq.sumTONSell)
            setDate(e)
        }
        else {
            let dataReq = await dispatch(actionGetListHistorySwapTON({ page: 1, user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '', ...data_filter }));
            setTotalXAUBuy(dataReq.sumXAUBuy)
            setTotalTONSell(dataReq.sumTONSell)
        }

    };

    const onSearchDelayed = _.debounce(() => onSearch(), 100)
    const onSearch = async () => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_ton, end_ton, start_xau, end_xau } = formRef.current.getFieldsValue()
        setVisibleSearch(true)
        let data_filter = { user_name_source: user_name_source ? user_name_source.trim() : '', transactionID: transactionID ? transactionID.trim() : '', user_name_destination: user_name_destination ? user_name_destination.trim() : '' }
        if (date[0] && date[1]) {
            data_filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        if (type !== '') {
            data_filter.type = type
        }
        if (start) {
            data_filter.start = start
        }
        if (start_ton) {
            data_filter.start_ton = start_ton
        }
        if (end_ton) {
            data_filter.end_ton = end_ton
        }
        if (start_xau) {
            data_filter.start_xau = start_xau
        }
        if (end_xau) {
            data_filter.end_xau = end_xau
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        let dataReq = await dispatch(actionGetListHistorySwapTON(data_filter));
        setTotalXAUBuy(dataReq.sumXAUBuy)
        setTotalTONSell(dataReq.sumTONSell)
        setVisible(false)
    }
    const renderStatus = (status, expirationDate) => {
        if (status === -1) {
            return (
                <Badge status="warning" text='Chờ hoàn tiền' />
            );
        } else if (status === 0 && Date.now() > new Date(expirationDate).getTime() ) {
            return (    
                <Badge status="warning" text='Hết hạn' />
            );
        } else if (status === 0) {
            return (
                <Badge status="warning" text='Chờ duyệt' />
            );
        } else if (status === 1) {
            return (
                <Badge status="processing" text='Thành công' />
            );
        } else if (status === 2) {
            return (
                <Badge status="success" text='Hoàn tiền' />
            );
        } else {
            return null
        }
    }
    const closeDetail = () => {
        setRecordModal(null)
        setFilterModal(null)
        setVisibleModalDetail(false)
    }
    const onOpenModal = (dataEdit) => {
        if (!dataEdit)
            setRecordModal(null)
        else
            setRecordModal(dataEdit)

        setFilterModal({
            name: dataSwapTON?.row?.user?.name,
            page: dataSwapTON?.paging?.page
        })
        setVisibleModalDetail(true)
    }

    const renderBodyTable = () => {
        return dataSwapTON?.rows?.length > 0
            ? dataSwapTON.rows.map((it, idx) => {
                return (
                    <tr key={`renderBodyTable_${it.id || idx}`}>
                        <td className="tr-center">
                            {(dataSwapTON?.paging?.page - 1) * dataSwapTON?.paging?.limit + idx + 1}
                        </td>
                        <td className="tr-center maxw--200">
                            {it?.user_id}
                        </td>
                        <td className="tr-center maxw--200">
                            {it?.comment}
                        </td>
                        <td className="tr-center maxw--300">
                            {it?.user?.fullname || "--"}
                        </td>
                        <td className="tr-center maxw--300">
                            {numberFormat((it?.amount), 5, ',', '.') || 0}
                        </td>
                        <td className="tr-center maxw--300">
                            {`1 XAUT = ${numberFormat((it?.price), 5, ',', '.')} TON` || 0}
                        </td>
                        <td className="tr-center maxw--300">
                            {formatCoin((it?.amount/it?.price), 5) || 0}
                        </td>
                        <td className="tr-center maxw--300">
                            {it?.createdAt ? moment(it?.createdAt).format('DD/MM/YYYY HH:mm:ss') : "Không xác định"}
                        </td>
                        <td className="tr-center maxw--300">
                            {it?.expired ? moment(it?.expired).format('DD/MM/YYYY HH:mm:ss') : "Không xác định"}
                        </td>
                        <td className="tr-center maxw--300">
                            {renderStatus(it?.status, it?.expired)}
                        </td>
                        <td className="tr-center maxw--300">
                            <ActionEditDelete
                                OverlayTrigger={true}
                                onclickView={() => onOpenModal(it)}
                                hideDelete={true}
                                hideEdit={true}
                            />
                        </td>
                    </tr>
                )
            })
            : <tr>
                <td className="tr-center" colSpan={12}>Không có dữ liệu hiển thị</td>
            </tr>
    }

    const onClearSearch = async () => {
        formRef.current.setFieldsValue({
            user_name_source: undefined,
            user_name_destination: undefined,
            transactionID: undefined,
            email_source: undefined,
            mobile_source: undefined,
            mobile: undefined,
            email: undefined,
            picker: undefined,
            start_ton: undefined,
            end_ton: undefined,
            start_xau: undefined,
            end_xau: undefined,
            type: ''
        })
        setCheckbox([])
        setDate([null, null])
        setVisibleSearch(false)

        // if (listUserLoginPermission.includes(TYPE.GIAO_DICH_MUA_XAU)) {
        //     let swapUSDXAU = await dispatch(actionGetListHistorySwapXAU({ page: 1, type: 'swap_USD_XAU' }));
        //     setTotalUSDBuy(swapUSDXAU.sumUSDBuy)
        //     setTotalUSDSell(swapUSDXAU.sumUSDSell)
        //     setTotalXAUBuy(swapUSDXAU.sumXAUBuy)
        //     setTotalXAUSell(swapUSDXAU.sumXAUSell)
        // } else {
        //     let dataReq = await dispatch(actionGetListHistorySwapXAU({ page: 1 }));
        //     setTotalUSDBuy(dataReq.sumUSDBuy)
        //     setTotalUSDSell(dataReq.sumUSDSell)
        //     setTotalXAUBuy(dataReq.sumXAUBuy)
        //     setTotalXAUSell(dataReq.sumXAUSell)
        // }
        let dataReq = await dispatch(actionGetListHistorySwapTON({ page: 1 }));
        setTotalXAUBuy(dataReq.sumXAUBuy)
        setTotalTONSell(dataReq.sumTONSell)
    }
    const onExportDelayed = async () => {
        let { user_name_source, email_source, mobile_source, user_name_destination, transactionID, email, mobile, type, start, end, start_ton, end_ton, start_xau, end_xau } = formRef.current.getFieldsValue()
        setVisibleSearch(true)

        const url = new URL(`${process.env.REACT_APP_API_URL}/admin/exportExcel/list-swap-ton`);
        const accessToken = localStorage.getItem('token');
        url.searchParams.append("token", accessToken);
        let data_filter = {
            user_name_source: user_name_source ? user_name_source.trim() : '',
            transactionID: transactionID ? transactionID.trim() : '',
            user_name_destination: user_name_destination ? user_name_destination.trim() : '',
        }
        if (date[0] && date[1]) {
            data_filter.date = [moment(date[0]).format('YYYY/MM/DD'), moment(date[1]).format('YYYY/MM/DD')]
        }
        if (type) {
            data_filter.type = type
        }
        if (start_ton) {
            data_filter.start_ton = start_ton
        }
        if (end_ton) {
            data_filter.end_ton = end_ton
        }
        if (start_xau) {
            data_filter.start_xau = start_xau
        }
        if (end_xau) {
            data_filter.end_xau = end_xau
        }
        if (end) {
            data_filter.end = end
        }
        if (email)
            data_filter.email = email.trim()
        if (mobile)
            data_filter.mobile = mobile.trim()
        if (email_source)
            data_filter.email_source = email_source.trim()
        if (mobile_source)
            data_filter.mobile_source = mobile_source.trim()
        Object.keys(data_filter).forEach(key => {
            url.searchParams.append(key, data_filter[key]);
        });
        window.open(url);
        // setVisibleSearch(false)
        // onClearSearch()
    }

    const enterKeyPressed = (event) => {
        if (event.keyCode == 13) {
            onSearch()
        }
    }

    const parserNumber = (val) => {
        if (!val) return 0;
        const resl = Number.parseFloat(val.replace(/\$\s?|(\.*)/g, "").replace(/(\,{1})/g, ".")).toFixed(5)
        return resl
    }
    return (
        <>
            <Card>
                <CardBody>

                    <Form
                        className="width100"
                        ref={formRef}
                    >
                        <div className="layout-form-header row">
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Mã giao dịch{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="transactionID"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập mã giao dịch"
                                    />
                                </Form.Item>
                            </div>

                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Tên khách hàng{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="user_name_source"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập tên khách hàng"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Email{` `}
                                </div>
                                <Form.Item
                                    className="email"
                                    name="email_source"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập email"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    SĐT{` `}
                                </div>
                                <Form.Item
                                    className="mobile"
                                    name="mobile_source"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập số điện thoại"
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="layout-form-header row">
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Lọc theo thời gian tạo{` `}
                                </div>
                                <Space className='customSpace'>
                                    <Form.Item
                                        name='picker'
                                    >
                                        <RangePicker allowClear onChange={(e) => onChangeDateRange(e)} placeholder={['Từ ngày', 'Đến ngày']} className='customDate' />
                                    </Form.Item>
                                </Space>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Trạng thái{` `}
                                </div>
                                <Form.Item
                                    name="type"
                                >
                                    <Select
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        placeholder="Chọn trạng thái"
                                        defaultValue={''}
                                        onChange={onSearchDelayed}
                                    >
                                        <Select.Option value={''}>Tất cả</Select.Option>
                                        <Select.Option value={-1}>Chờ hoàn tiền</Select.Option>
                                        <Select.Option value={0}>Chờ duyệt</Select.Option>
                                        <Select.Option value={-2}>Hết hạn</Select.Option>
                                        <Select.Option value={1}>Thành công</Select.Option>
                                        <Select.Option value={2}>Hoàn tiền</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Lọc theo số lượng TON
                                </div>
                                <div className='mb--16'>
                                    <Form.Item
                                        className=""
                                        name="start_ton"
                                        label={(<span style={{ width: 30 }} >Từ</span>)}
                                    >
                                        <InputNumber
                                            formatter={(value) => formatCoin(value, 4)}
                                            parser={(value) => parserNumber(value)}
                                            step={1}
                                            className="customInput width80"
                                        />
                                    </Form.Item>
                                </div>
                                <Form.Item
                                    className=""
                                    name="end_ton"
                                    label={(<span style={{ width: 30 }} >Đến</span>)}
                                >
                                    <InputNumber
                                        formatter={(value) => formatCoin(value, 4)}
                                        parser={(value) => parserNumber(value)}
                                        step={1}
                                        className="customInput width80"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Lọc theo số lượng XAUT
                                </div>
                                <div className='mb--16'>
                                    <Form.Item
                                        className=""
                                        name="start_xau"
                                        label={(<span style={{ width: 30 }} >Từ</span>)}
                                    >
                                        <InputNumber
                                            formatter={(value) => formatCoin(value, 5)}
                                            parser={(value) => parserNumber(value)}
                                            step={1}
                                            className="customInput width80"
                                        />
                                    </Form.Item>
                                </div>
                                <Form.Item
                                    className=""
                                    name="end_xau"
                                    label={(<span style={{ width: 30 }} >Đến</span>)}
                                >
                                    <InputNumber
                                        formatter={(value) => formatCoin(value, 5)}
                                        parser={(value) => parserNumber(value)}
                                        step={1}
                                        className="customInput width80"
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="mb--20 row-end">
                            <CustomButton
                                className="mr--10"
                                title="Tìm kiếm"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onSearchDelayed}
                            />
                            {visibleSearch && <CustomButton
                                className="customClearSearch mr--10"
                                title="Bỏ lọc"
                                btnBgColor="#eceef7"
                                btnColor="#192038"
                                btnHoverBackground="#eceef7"
                                onClick={onClearSearch}
                            />}
                            <CustomButton
                                className="mr--10"
                                title="Xuất file"
                                btnBgColor="#838d20"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onExportDelayed}
                            />
                        </div>
                        <div className="d-flex space-between col-12">
                            <div className=""><span className="b--700">Tổng số:{' '}</span>{dataSwapTON?.total || 0}</div>
                            <div className=""><span className="b--700">Tổng số TON đã bán:{' '}</span>{numberFormat((totalTONSell), 5, ',', '.') || 0}</div>
                            <div className=""><span className="b--700">Tổng số XAUT đã mua:{' '}</span>{formatCoinID((totalXAUBuy), 5) || 0}</div>
                        </div>
                        <div className="customTableCtn">
                            <table className="customTable">
                                <tr className="bg-E6F8FD">
                                    <th className="tr-center">STT</th>
                                    <th className="tr-center">Mã KH</th>
                                    <th className="tr-center">Mã giao dịch</th>
                                    <th className="tr-center">Tên khách hàng</th>
                                    <th className="tr-center">Số lượng (TON)</th>
                                    <th className="tr-center">Tỉ giá</th> 
                                    <th className="tr-center">Số lượng (XAUT)</th>
                                    <th className="tr-center">Thời gian tạo</th>
                                    <th className="tr-center">Thời gian hết hạn</th>
                                    <th className="tr-center">Trạng thái</th>
                                    <th className="tr-center">Thao tác</th>
                                </tr>
                                {renderBodyTable()}
                            </table>
                        </div>
                        <div className="mt--20 rowx-center">
                            {dataSwapTON?.paging?.total > dataSwapTON?.paging?.limit && <div className="mt--20 rowx-center">
                                <Pagination
                                    count={dataSwapTON?.paging?.count} //total
                                    page={dataSwapTON?.paging?.page} //current page
                                    variant="outlined" shape="rounded" showFirstButton showLastButton
                                    onChange={(event, page) => onChangePage(event, page)}
                                />
                            </div>}
                        </div>
                    </Form>


                </CardBody>
            </Card>
            <Suspense fallback={<div></div>}>
                <section>
                    {visibleModalDetail && <DetailSwapTON
                        onCloseModal={closeDetail}
                        visibleModal={visibleModalDetail}
                        recordModal={recordModal}
                        filterModal={filterModal}
                    />}
                </section>
            </Suspense>
        </>
    );
};
export default injectIntl(withRouter(ListSwapTON));